import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-placement-builder-meta',
  imports: [],
  templateUrl: './placement-builder-meta.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './placement-builder-meta.component.css'
})
export class PlacementBuilderMetaComponent {

}
